import { z } from 'zod';

import { eventEnvelopeSchema } from './base.js';

export const apiKeyRevokedV1Schema = eventEnvelopeSchema.extend({
  merchantName: z.string().min(1).max(256).optional(),
  keyId: z.string().min(1).max(256),
});

export type ApiKeyRevokedV1 = z.infer<typeof apiKeyRevokedV1Schema>;

export const API_KEY_REVOKED_V1_DETAIL_TYPE = 'api-key.revoked.v1' as const;
